module.exports = __webpack_public_path__ + "img/background.1b6d965a.png";